import { useState } from "react";
import { Button } from "@/components/ui/button";
import { Card } from "@/components/ui/card";
import { ChevronDown, ChevronUp } from "lucide-react";

interface OriginalPromptCardProps {
  originalText: string;
}

export function OriginalPromptCard({ originalText }: OriginalPromptCardProps) {
  const [expanded, setExpanded] = useState(false);

  return (
    <Card className="bg-card border border-border rounded-2xl p-4 md:p-6 fade-in-up opacity-0 stagger-1">
      <button 
        className="flex items-center justify-between w-full"
        onClick={() => setExpanded(!expanded)}
      >
        <div className="flex items-center gap-2">
          <div className="w-2 h-2 rounded-full bg-muted-foreground" />
          <h3 className="font-display font-semibold text-muted-foreground">Your Original</h3>
        </div>
        <div className="flex items-center gap-2 text-muted-foreground">
          {expanded ? (
            <ChevronUp className="w-4 h-4" />
          ) : (
            <ChevronDown className="w-4 h-4" />
          )}
        </div>
      </button>
      
      {expanded && (
        <div className="bg-muted/30 rounded-xl p-4 border border-border/50 mt-4">
          <p className="text-foreground leading-relaxed whitespace-pre-wrap">
            {originalText}
          </p>
        </div>
      )}
    </Card>
  );
}
